import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './app/providers/AuthProvider';
import { QueryProvider } from './app/providers/QueryProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { 
  ErrorBoundary, 
  setupGlobalErrorHandlers, 
  handleError, 
  ErrorNotificationListener 
} from './utils/errorHandler';
import { NotificationsProvider } from './ui/notifications';

if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    if (event.error && event.error.stack && event.error.stack.includes('react-dom')) {
      event.stopImmediatePropagation();
      handleError(event.error, { type: 'React Render' });
    }
  });
}

// Setup global error handlers as early as possible
setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <NotificationsProvider>
        <ErrorNotificationListener />
        <I18nextProvider i18n={i18n}>
          <AuthProvider>
            <QueryProvider>
              <App />
            </QueryProvider>
          </AuthProvider>
        </I18nextProvider>
      </NotificationsProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
